import { ACCOUNT_SCOPE_STATUS, TypeIdSchema, accountScope } from '@unipile/db';
import { Static, Type } from '@sinclair/typebox';
import { createInsertSchema, createSelectSchema } from 'drizzle-typebox';
import { StringEnum } from '../../utils/typebox';

export const ScopeStatusSchema = StringEnum([...ACCOUNT_SCOPE_STATUS], {
  description:
    'The status of the Scope. A disabled scope blocks its scoped API keys and authentication flows until it is enabled again.',
});
export const ScopeRecordSchema = createSelectSchema(accountScope, { status: ScopeStatusSchema });
export const InsertScopeSchema = createInsertSchema(accountScope, { status: ScopeStatusSchema });

export const PublicScopeSchema = Type.Object({
  object: Type.Literal('Scope', { description: 'The type of the returned object.' }),
  id: TypeIdSchema('accountScope', { description: 'The unique public ID of the Scope.' }),
  application_id: TypeIdSchema('app', { description: 'The ID of the Application that owns the Scope.' }),
  name: Type.String({ description: 'The internal name of the Scope.' }),
  reference: Type.Union([Type.String(), Type.Null()], {
    description: 'External metadata used to map the Scope to another resource, or `null` when none is defined.',
  }),
  status: ScopeStatusSchema,
  created_at: Type.String({ description: 'The date and time when the Scope was created.' }),
  accounts_count: Type.Number({ description: 'The number of Accounts permanently assigned to the Scope.' }),
  api_keys_count: Type.Number({ description: 'The number of API Keys assigned to the Scope.' }),
});

export type ScopeRecord = typeof accountScope.$inferSelect;
export type InsertScope = typeof accountScope.$inferInsert;
export type PublicScope = Static<typeof PublicScopeSchema>;
